import { gql } from 'react-apollo';

export default gql`
  query filteredOptions($tenantId: ID) {
    filteredOptions(tenantId: $tenantId) {
      sectors
      areas
      listingTypes
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/filteredOptions.js